// React
import { useCallback } from 'react';
import { useLoaderData } from 'react-router-dom';

// Hooks
import { usePreviewData } from '@/hooks/usePreviewData';

// Utils
import { getSlug } from '@/utils/slug';

// Services
import { getHeader } from '@/services/header/headerService';
import { getFooter } from '@/services/footer/footerService';
import { getTechno } from '@/services/techno/technoService';

// Components
import LayoutHeaderFooter from '@/components/layout/LayoutHeaderFooter/LayoutHeaderFooter';
import { PageBlocks } from '@/components/blocks/Blocks';

// Styles
import { Helmet } from 'react-helmet';
import { RoutesEnum } from '@/enum/RoutesEnum';
import styles from './Techno.module.css';

export async function technoLoader({ request }: { request: Request }) {
  const slug = getSlug(new URL(request.url));

  if (!slug) return null;

  const [header, footer, page] = await Promise.all([getHeader(), getFooter(), getTechno(slug)]);

  return {
    header,
    footer,
    page,
  };
}

function Techno() {
  const loaderData = useLoaderData() as Awaited<ReturnType<typeof technoLoader>>;
  const refetch = useCallback(
    () => technoLoader({ request: new Request(window.location.href) }),
    [],
  );
  const data = usePreviewData(loaderData, refetch);
  const baseUrl = import.meta.env.VITE_DOMAIN;

  if (!data) return null;

  const { header, footer, page } = data;

  if (!page) return null;

  return (
    <main>
      <Helmet>
        <title>{page.seo.metaTitle}</title>
        <meta name="description" content={page.seo.metaDescription} />
        <link rel="canonical" href={`${baseUrl}/${RoutesEnum.TECHNOS}/${page.slug}`} />
      </Helmet>
      <LayoutHeaderFooter header={header} footer={footer}>
        <div className={styles.body}>
          <PageBlocks blocks={page.blocks} />
        </div>
      </LayoutHeaderFooter>
    </main>
  );
}

export default Techno;
